export const LIB_CATS = [
  ["oracao", "Pedido de oração"], ["fotografia", "Fotografia"], ["testemunho", "Testemunho"], ["comprovante", "Comprovante Pix"],
  ["deus_provera", "Deus Proverá"], ["endereco", "Endereço da igreja"], ["horarios", "Horários de reuniões"],
  ["informacoes", "Informações gerais"], ["agradecimentos", "Agradecimentos"],
];
export const LIB_LABEL = Object.fromEntries(LIB_CATS);

export const AUDIO_EXT = ["ogg", "oga", "opus", "mp3", "mpeg", "mpga", "mp2", "m4", "m4a", "m4b", "mp4", "aac", "wav", "wave", "flac",
  "amr", "3gp", "3ga", "caf", "wma", "aif", "aiff", "webm", "weba"];
export const AUDIO_ACCEPT = ["audio/*", ...AUDIO_EXT.map((e) => `.${e}`)].join(",");

export const personalize = (text, name) => {
  const first = (name || "").split(" ")[0];
  return text.replaceAll("{primeiro_nome}", first).replaceAll("{nome}", first);
};
